module.exports = __webpack_public_path__ + "vue/img/logo_white.53bf6d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo_white.svg
// module id = FOMP
// module chunks = 1